export class StatusCuti {
    public static readonly DRAFT = 1;
    public static readonly DIAJUKAN = 2;
    public static readonly DISETUJUI = 3;
    public static readonly PERUBAHAN = 4;
    public static readonly DITANGGUHKAN = 5;
    public static readonly TIDAK_DISETUJUI = 6;

    public static readonly DISETUJUI_ATASAN = 31;
    public static readonly DISETUJUI_PEJABAT = 32;
    public static readonly DISETUJUI_ATASAN_PEJABAT = 33;

    public static readonly TIDAK_DISETUJUI_ATASAN = 61;
    public static readonly TIDAK_DISETUJUI_PEJABAT = 62;
    public static readonly TIDAK_DISETUJUI_ATASAN_PEJABAT = 66;
}
